import SessionError from '../session-error/SessionError';

export const AbortedStep = () => {
	return <SessionError errorMessage="Aborted" />;
};
